// extracted by mini-css-extract-plugin
module.exports = {"content":"terms_content__Zd1e5","loader":"terms_loader__HgXq2","container":"terms_container__7kuna","legal-pages-nav--mobile":"terms_legal-pages-nav--mobile__CTcWG"};